// ======================================================================
// File Name       : userfrontImage
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import _ from 'lodash';
import * as ActionTypes from '../constants/actionTypes/userfrontImage';
import {
  isUserfrontImageLoginType,
  isUserfrontImageTopType, MULTILANG_TYPE, TITLE_OBJ,
  TITLE_OBJ_STR,
  USERFRONT_IMAGE_SCREEN_TYPE
} from '../constants/UserfrontImageConstants';
import { downLoadFile } from '../utils/ApiUtils';
import { INITIAL_IMAGE } from '../constants/InitialImageConstants';

const initialState = {
  initialData: {
    imageFileUpload: null,
    userfrontImageType: null,
    multiLangType: null,
    thumbnailUrl: '',
    imageOptionalUrl: '',
    imageDownloadUrl: '',
  },
  initialImageObject: null,
  imageObject: null,
  storeUserfrontImageSettingList: [],
  storeUserfrontDisplaySettingInfo: {},
  userfrontDisplaySettingInfo: {},
  languageSetting: MULTILANG_TYPE.NORMAL_IMAGE,
};

function addNameAndTitle(obj, index) {
  switch (index) {
    case 0:
      obj.name = TITLE_OBJ.PC_BACKGROUND;
      obj.titleName = TITLE_OBJ_STR.PC_BACKGROUND;
      break;
    case 1:
      obj.name = TITLE_OBJ.PC_LOGIN_LOGO;
      obj.titleName = TITLE_OBJ_STR.PC_LOGIN_LOGO;
      break;
    case 2:
      obj.name = TITLE_OBJ.SP_LOGO;
      obj.titleName = TITLE_OBJ_STR.SP_LOGO;
      break;
    default:
      break;
  }
  return obj;
}

function addNameAndTitleForTop(obj, index) {
  switch (index) {
    case 3:
      obj.name = TITLE_OBJ.HERO_AREA;
      obj.titleName = TITLE_OBJ_STR.HERO_AREA;
      break;
    case 4:
      obj.name = TITLE_OBJ.BANNER_1;
      obj.titleName = TITLE_OBJ_STR.BANNER_1;
      break;
    case 5:
      obj.name = TITLE_OBJ.BANNER_2;
      obj.titleName = TITLE_OBJ_STR.BANNER_2;
      break;
    case 6:
      obj.name = TITLE_OBJ.BANNER_3;
      obj.titleName = TITLE_OBJ_STR.BANNER_3;
      break;
    default:
      break;
  }
  return obj;
}

function createObjEmpty() {
  const listObj = [];
  for (let i = 0; i < 2; i++) {
    let obj = {
      userfrontImageType: i,
      thumbnailUrl: '',
      imageOptionalUrl: '',
      imageDownloadUrl: '',
    };
    obj = addNameAndTitle(obj, i);
    listObj.push(obj);
  }
  const objListObj = toObject(listObj);
  return objListObj;
}

function createObjEmptyForTop() {
  const listObj = [];
  for (let i = 3; i < 6; i++) {
    let obj = {
      userfrontImageType: i,
      thumbnailUrl: '',
      imageOptionalUrl: '',
      imageDownloadUrl: '',
    };
    obj = addNameAndTitleForTop(obj, i);
    listObj.push(obj);
  }
  const objListObj = toObject(listObj);
  return objListObj;
}

function toObject(arr) {
  const rv = {};
  for (let i = 0; i < arr.length; ++i) { rv[arr[i].name] = arr[i]; }
  return rv;
}

export default function initialImage(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.USERFRONT_INITIAL_IMAGE_LIST: {
      const { userfrontImageSettingList, userfrontDisplaySettingInfo } = action.initialImageList;
      const { languageSetting } = state;
      let imageSettingResult = {};
      let obj = null;
      let key = null;
      const imageObject = {};
      if (!userfrontImageSettingList && !userfrontImageSettingList.length) {
        obj = createObjEmpty();
      } else {
        userfrontImageSettingList.sort((a, b) => {
          const typeA = a.userfrontImageType;
          const typeB = b.userfrontImageType;
          if (Number.isNaN(typeA) || Number.isNaN(typeB)) return 0;
          if (typeA < typeB) return -1;
          if (typeA > typeB) return 1;
          return 0;
        });

        imageSettingResult = userfrontImageSettingList.reduce(
          (acc, cur) => {
            const { userfrontImageType, multilangType } = cur;
            if (isUserfrontImageLoginType(userfrontImageType)
              && multilangType === languageSetting) {
              cur = addNameAndTitle(cur, userfrontImageType);
              key = `${cur.name}`;
              acc.userfrontImageType[key] = cur;
              imageObject[key] = cur;
            }
            return acc;
          },
          {
            userfrontImageType: {},
          },
        );
        obj = imageSettingResult.userfrontImageType;

        // push data of userfrontDisplaySettingInfo
        if (userfrontDisplaySettingInfo) {
          const { loginBackgroundFlag, loginPanelLogoFlag } = userfrontDisplaySettingInfo;
          imageObject[TITLE_OBJ.PC_BACKGROUND].isEnableFileUpload = loginBackgroundFlag;
          imageObject[TITLE_OBJ.PC_LOGIN_LOGO].isEnableFileUpload = loginPanelLogoFlag;
          imageObject[TITLE_OBJ.PC_BACKGROUND].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
          imageObject[TITLE_OBJ.PC_LOGIN_LOGO].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
        }

        obj = _.merge(imageSettingResult.userfrontImageType, userfrontDisplaySettingInfo);
      }
      return {
        ...state,
        initialImageObject: obj,
        imageObject,
        storeUserfrontImageSettingList: userfrontImageSettingList,
        storeUserfrontDisplaySettingInfo: userfrontDisplaySettingInfo,
      };
    }

    case ActionTypes.USERFRONT_INITIAL_TOP_IMAGE_LIST: {
      const { userfrontImageSettingList, userfrontDisplaySettingInfo } = action.initialImageList;
      const { languageSetting } = state;
      let imageSettingResult = {};
      let obj = null;
      let key = null;
      const imageObject = {};
      if (!userfrontImageSettingList && !userfrontImageSettingList.length) {
        obj = createObjEmptyForTop();
      } else {
        userfrontImageSettingList.sort((a, b) => {
          const typeA = parseInt(a.userfrontImageType, 10);
          const typeB = parseInt(b.userfrontImageType, 10);
          if (Number.isNaN(typeA) || Number.isNaN(typeB)) return 0;
          if (typeA < typeB) return -1;
          if (typeA > typeB) return 1;
          return 0;
        });

        imageSettingResult = userfrontImageSettingList.reduce(
          (acc, cur) => {
            const { userfrontImageType, multilangType } = cur;
            if (isUserfrontImageTopType(userfrontImageType)
              && multilangType === languageSetting) {
              cur = addNameAndTitleForTop(cur, userfrontImageType);
              key = `${cur.name}`;
              acc.userfrontTopImageType[key] = cur;
              imageObject[key] = cur;
            }
            return acc;
          },
          {
            userfrontTopImageType: {},
          },
        );
        obj = imageSettingResult.userfrontTopImageType;

        // push data of userfrontDisplaySettingInfo
        if (userfrontDisplaySettingInfo) {
          const { heroAreaFlag, bannerFlag1, bannerFlag2, bannerFlag3 } = userfrontDisplaySettingInfo;
          imageObject[TITLE_OBJ.HERO_AREA].isEnableFileUpload = heroAreaFlag;
          imageObject[TITLE_OBJ.BANNER_1].isEnableFileUpload = bannerFlag1;
          imageObject[TITLE_OBJ.BANNER_2].isEnableFileUpload = bannerFlag2;
          imageObject[TITLE_OBJ.BANNER_3].isEnableFileUpload = bannerFlag3;
          imageObject[TITLE_OBJ.HERO_AREA].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
          imageObject[TITLE_OBJ.BANNER_1].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
          imageObject[TITLE_OBJ.BANNER_2].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
          imageObject[TITLE_OBJ.BANNER_3].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
        }

        obj = _.merge(imageSettingResult.userfrontTopImageType, userfrontDisplaySettingInfo);
      }
      return {
        ...state,
        initialImageObject: obj,
        imageObject,
        storeUserfrontImageSettingList: userfrontImageSettingList,
        storeUserfrontDisplaySettingInfo: userfrontDisplaySettingInfo,
      };
    }

    case ActionTypes.USERFRONT_CHANGE_IMAGE_FILE: {
      const imageObject = { ...state.imageObject };
      const { nameKey, newFormValue } = action.data;

      // update form values
      imageObject[nameKey] = newFormValue;
      return {
        ...state,
        imageObject,
      };
    }

    case ActionTypes.USERFRONT_CHANGE_IMAGE_DATA: {
      const { storeUserfrontImageSettingList, storeUserfrontDisplaySettingInfo } = state;
      const { userfrontScreenType, languageSetting } = action.data;
      let result = {};
      let key = null;
      let obj = null;
      const imageObject = {};
      result = storeUserfrontImageSettingList.reduce(
        (acc, cur) => {
          if (userfrontScreenType === USERFRONT_IMAGE_SCREEN_TYPE.LOGIN) { // ログイン画面画像設定
            if (isUserfrontImageLoginType(cur.userfrontImageType)
              && cur.multilangType === languageSetting) {
              cur = addNameAndTitle(cur, cur.userfrontImageType);
              key = `${cur.name}`;
              acc.userfrontImageType[key] = cur;
              imageObject[key] = cur;
            }
          } else if (userfrontScreenType === USERFRONT_IMAGE_SCREEN_TYPE.TOP) { // ログイン後トップ画面
            if (isUserfrontImageTopType(cur.userfrontImageType)
              && cur.multilangType === languageSetting) {
              cur = addNameAndTitleForTop(cur, cur.userfrontImageType);
              key = `${cur.name}`;
              acc.userfrontImageType[key] = cur;
              imageObject[key] = cur;
            }
          }
          return acc;
        },
        {
          userfrontImageType: {},
        },
      );
      obj = result.userfrontImageType;

      if (userfrontScreenType === USERFRONT_IMAGE_SCREEN_TYPE.LOGIN) {
        if (storeUserfrontDisplaySettingInfo) {  // push data of userfrontDisplaySettingInfo
          const { loginBackgroundFlag, loginPanelLogoFlag } = storeUserfrontDisplaySettingInfo;
          imageObject[TITLE_OBJ.PC_BACKGROUND].isEnableFileUpload = loginBackgroundFlag;
          imageObject[TITLE_OBJ.PC_LOGIN_LOGO].isEnableFileUpload = loginPanelLogoFlag;

          imageObject[TITLE_OBJ.PC_BACKGROUND].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
          imageObject[TITLE_OBJ.PC_LOGIN_LOGO].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
        }
      } else if (userfrontScreenType === USERFRONT_IMAGE_SCREEN_TYPE.TOP) {
        // push data of userfrontDisplaySettingInfo
        if (storeUserfrontDisplaySettingInfo) {
          const { heroAreaFlag, bannerFlag1, bannerFlag2, bannerFlag3 } = storeUserfrontDisplaySettingInfo;
          imageObject[TITLE_OBJ.HERO_AREA].isEnableFileUpload = heroAreaFlag;
          imageObject[TITLE_OBJ.BANNER_1].isEnableFileUpload = bannerFlag1;
          imageObject[TITLE_OBJ.BANNER_2].isEnableFileUpload = bannerFlag2;
          imageObject[TITLE_OBJ.BANNER_3].isEnableFileUpload = bannerFlag3;

          imageObject[TITLE_OBJ.HERO_AREA].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
          imageObject[TITLE_OBJ.BANNER_1].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
          imageObject[TITLE_OBJ.BANNER_2].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
          imageObject[TITLE_OBJ.BANNER_3].imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
        }

        // merge data
        obj = _.merge(result.userfrontImageType, storeUserfrontDisplaySettingInfo);
      }

      return {
        ...state,
        initialImageObject: obj,
        imageObject,
        languageSetting,
      };
    }

    case ActionTypes.USERFRONT_GET_IMAGE_DATA: {
      const imageObject = { ...state.imageObject };
      const { key, dataUrl } = action.data;
      if (imageObject && Object.keys(imageObject).length && imageObject[key]) {
        imageObject[key].dataUrl = dataUrl;
      }

      return {
        ...state,
        imageObject,
      };
    }

    case ActionTypes.USERFRONT_RESET_INIT_STATE: {
      const {
        initialImageObject,
        imageObject,
        storeUserfrontImageSettingList,
        storeUserfrontDisplaySettingInfo,
        languageSetting,
      } = initialState;
      return {
        ...state,
        initialImageObject,
        imageObject,
        storeUserfrontImageSettingList,
        storeUserfrontDisplaySettingInfo,
        languageSetting,
      };
    }

    default: {
      return state;
    }
  }
}
